exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dropdown-custom .custom-button {\n  display: inline-flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/pages/Raroc/UploadFile/dropdown.style.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/resolve-url-loader/index.js!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/pages/Raroc/UploadFile/dropdown.style.scss
// module chunks = 0